import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouteReuseStrategy } from '@angular/router';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { AuthInterceptor } from './core/interceptors/auth.interceptor';
import { ThemeToggleComponent } from './shared/components/theme-toggle/theme-toggle.component';
import { PlaylistCardComponent } from './shared/components/playlist-card/playlist-card.component';
import { LangSwitcherComponent } from './shared/components/lang-switcher/lang-switcher.component';
import { BackButtonComponent } from './shared/components/back-button/back-button.component';
import { HelpHintComponent } from './shared/components/help-hint/help-hint.component';
import { CookieConsentDialogComponent } from './shared/components/cookie-consent-dialog/cookie-consent-dialog.component';
import { AdSlotComponent } from './shared/components/ad-slot/ad-slot.component';
import { TranslatePipe } from './shared/pipes/translate.pipe';
import { LoginPage } from './pages/auth/login/login.page';
import { RegisterPage } from './pages/auth/register/register.page';
import { HomePage } from './pages/home/home.page';
import { ConvertPage } from './pages/convert/convert.page';
import { PlaylistsPage } from './pages/playlists/playlists.page';
import { AccountPage } from './pages/account/account.page';
import { LandingPage } from './pages/landing/landing.page';
import { ConnectCallbackPage } from './pages/connect-callback/connect-callback.page';
import { OauthSuccessPage } from './pages/oauth-success/oauth-success.page';
import { TokensInfoPage } from './pages/tokens-info/tokens-info.page';
import { TermsPage } from './pages/terms/terms.page';
import { PrivacyPage } from './pages/privacy/privacy.page';
import { CookieSettingsPage } from './pages/cookie-settings/cookie-settings.page';

@NgModule({
  declarations: [
    AppComponent,
    ThemeToggleComponent,
    CookieConsentDialogComponent,
    AdSlotComponent,
    PlaylistCardComponent,
    LangSwitcherComponent,
    BackButtonComponent,
    HelpHintComponent,
    TranslatePipe,
    LoginPage,
    RegisterPage,
    HomePage,
    ConvertPage,
    PlaylistsPage,
    AccountPage,
    LandingPage,
    ConnectCallbackPage,
    OauthSuccessPage,
    TokensInfoPage,
    TermsPage,
    PrivacyPage,
    CookieSettingsPage
  ],
  imports: [
    BrowserModule,
    IonicModule.forRoot(),
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    AppRoutingModule
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    },
    {
      provide: RouteReuseStrategy,
      useClass: IonicRouteStrategy
    }
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  bootstrap: [AppComponent]
})
export class AppModule {}
